<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="10">
        <div class="pa-6 text-right" style="font-size: 24px">
          <div>รวมทั้งหมด <span style="font-size: 30px">{{ filtered_data.length }}</span> รายการ</div>
        </div>
        <div class="pa-4">
          <v-card-title>
            <div class="d-flex flex-wrap align-center" style="width: 100%; gap: 16px;">
              <v-select
                v-model="selected_month"
                :items="months"
                label="เลือกเดือน"
                color="#86bc3a"
                dense
                outlined
                clearable
                style="max-width: 200px;"
              ></v-select>
              <v-select
                v-model="selected_year"
                :items="years"
                label="เลือกปี"
                color="#86bc3a"
                dense
                outlined
                clearable
                style="max-width: 180px;"
              ></v-select>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                color="#86bc3a"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
                style="max-width: 300px;"
              ></v-text-field>
            </div>
          </v-card-title>
          <v-data-table v-model="selected" checkbox-color="#86bc3a" show-select item-key="warehouse_id" :headers="details_headers" :items="filtered_data" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:body="{ items }">
              <tbody>
                <tr  v-for="item in items" :key="item.warehouse_id">
                  <td><v-checkbox color="#86bc3a" v-model="selected" :value="item"/></td>
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.lot_no }}</td>
                  <td>{{ item.date_expired }}</td>
                  <td class="text-center">{{ format_number(item.quantity) }}</td>
                  <td>{{ item.unit }}</td>
                  <td>{{ item.supplier }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
        <div class="pa-6 text-right">
          <v-btn x-large class="grad-danger-bg white--text mobile_btn" @click="save_data">ย้ายเข้าคลังใกล้หมดอายุ</v-btn>
        </div>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </v-card>
    </div>
  </div>
</template>

<script>

import {HTTP} from "@/axios";
import Swal from "sweetalert2";
import {diffDateTH, formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Storage_exp",
  data(){
    return {
      search: null,
      loading_page: false,
      expire_data: [],
      data_set: [],
      selected: [],
      overlay: false,
      selected_month: null,
      selected_year: null,
      months: [
        { text: 'มกราคม', value: 1 },
        { text: 'กุมภาพันธ์', value: 2 },
        { text: 'มีนาคม', value: 3 },
        { text: 'เมษายน', value: 4 },
        { text: 'พฤษภาคม', value: 5 },
        { text: 'มิถุนายน', value: 6 },
        { text: 'กรกฎาคม', value: 7 },
        { text: 'สิงหาคม', value: 8 },
        { text: 'กันยายน', value: 9 },
        { text: 'ตุลาคม', value: 10 },
        { text: 'พฤศจิกายน', value: 11 },
        { text: 'ธันวาคม', value: 12 }
      ],
      years: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      details_headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '300px',
        },
      ],
    }
  },
  computed: {
    filtered_data() {
      // ไม่มีการเลือกเดือน/ปี -> แสดงทั้งหมด
      if (!this.selected_month && !this.selected_year) {
        return this.expire_data
      }

      return this.expire_data.filter(item => {
        if (!item.date_expired) return false

        // แปลงรูปแบบวันที่ไทย DD/MM/YYYY(พ.ศ. หรือ ค.ศ.)
        const parts = item.date_expired.split('/')
        if (parts.length !== 3) return false

        const day = parseInt(parts[0], 10)
        const month = parseInt(parts[1], 10)
        let year = parseInt(parts[2], 10)

        if (isNaN(day) || isNaN(month) || isNaN(year)) return false

        // ถ้าเป็นปี พ.ศ. ให้ลบ 543 เป็น ค.ศ.
        if (year > 2500) {
          year = year - 543
        }

        let match = true

        if (this.selected_month) {
          match = match && month === this.selected_month
        }

        if (this.selected_year) {
          match = match && year === this.selected_year
        }

        return match
      })
    }
  },
  methods: {
    diffTH: function(value) {
      return diffDateTH(value)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    extractYears() {
      const yearSet = new Set()
      this.expire_data.forEach(item => {
        if (!item.date_expired) return
        const parts = item.date_expired.split('/')
        if (parts.length !== 3) return
        let year = parseInt(parts[2], 10)
        if (isNaN(year)) return
        if (year > 2500) {
          year = year - 543
        }
        yearSet.add(year)
      })

      this.years = Array.from(yearSet)
        .sort((a, b) => b - a)
        .map(year => ({
          text: `พ.ศ. ${year + 543}`,
          value: year
        }))
    },
    getExpire_data() {
      this.loading_page = true
      HTTP.post('/inventory/getexp')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.expire_data = res.data.object
              // res.data.object.forEach((data, index) => {
              //   this.expire_data[index].status_check = false
              // })
              this.selected = []
              this.extractYears()
            }
          })
    },
    selected_all(event) {
      if (event.status) {
        alert('selected all')
      } else {
        alert('deselected all')
      }
    },
    save_data() {
      // console.log(this.selected)
      // const value = this.expire_data.filter((data) => data.status_check === true)
      // value.forEach((data) => {
      //   if (data.status_check === true) {
      //     data.status_check = 1
      //   }
      //   else {
      //     data.status_check = 0
      //   }
      // })
      if (this.selected.length > 0) {
        Swal.fire({
          title: 'ต้องการย้ายเข้าคลังหมดอายุหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('/inventory/movetoexpbylists', {
              user_create: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              data_set: this.selected,
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                Swal.fire({
                  title: 'ดำเนินการย้ายคลังสำเร็จ !',
                  icon: 'success',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
                this.getExpire_data()
              }
            })
          }
          else {
            this.getExpire_data()
          }
        })
      }else {
        Swal.fire({
          title: 'กรุณาเลือกข้อมูลที่ต้องการย้าย !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    }
  },
  mounted() {
    this.getExpire_data()
  }
}
</script>

<style scoped>
.mobile_btn {
  width: 25%;
}
.grid_unit {
  display: grid;
  grid-template-columns: 55% 45%;
}
@media only screen and (max-width: 500px) {
  .mobile_btn {
    width: 100%;
  }
}
</style>
